import Carousel from "./Carousel";
import InfiniteCarousel from "./InfiniteMovingCard";
import ImageGrid from "./mostSaleProduct";

const Home = () => {
  return (
    <>
      <Carousel />
      <ImageGrid />
      <InfiniteCarousel />
    </>
  );
};

export default Home;
